// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var PanelDisplayMode;
(function (PanelDisplayMode) {
    PanelDisplayMode[PanelDisplayMode["Allowed"] = 1] = "Allowed";
    PanelDisplayMode[PanelDisplayMode["NotAllowed"] = 2] = "NotAllowed";
    PanelDisplayMode[PanelDisplayMode["Offline"] = 3] = "Offline";
})(PanelDisplayMode || (PanelDisplayMode = {}));
